import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { normalizeUrl } from '@/utils/url';

export default function Link({ href, ...props }) {
  const normalizedHref = normalizeUrl(href, false); // false to remove trailing slash
  return <NextLink href={normalizedHref} {...props} />;
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
};